import {
  useCallback,
  useEffect
} from 'react';
import {
  useDispatch
} from 'react-redux';
import {
  CurrencyCodesEnum
} from '@shared/types';
import {
  toggleCurrencyCode,
  useSessionSelector,
  selectHasSCForbiddenTag,
} from '@entities/session';

export type UseToggleCurrencyUnlessSCForbidden = (newValue: CurrencyCodesEnum) => () => void;
export const useToggleCurrencyUnlessSCForbidden = (): UseToggleCurrencyUnlessSCForbidden => {
  const dispatch = useDispatch();
  const hasSCForbiddenTag = useSessionSelector(selectHasSCForbiddenTag);

  useEffect(() => {
    if (hasSCForbiddenTag) dispatch(toggleCurrencyCode(CurrencyCodesEnum.GCO));
  }, [dispatch, hasSCForbiddenTag]);

  const handleToggle = useCallback((newValue: CurrencyCodesEnum) => (): void => {
    dispatch(toggleCurrencyCode(newValue));
  }, []);

  return handleToggle;
};